module.exports = __webpack_public_path__ + "static/media/TopBG.f0a0aad6.svg";